import React from "react";
import "./WidgetContent.css";

function WidgetContent() {
  return (
    <div className="widget__contents">
      <div className="widget__content">
        <img src="https://qphs.fs.quoracdn.net/main-thumb-ti-1646645-50-yivziwjmefotolsaxijyzzlqbkwywlgq.jpeg" alt='' />
        <div className="widget__contentTitle">
          <h5>IT Companies & Employees</h5>
                <p>Know IT World</p>
        </div>
      </div>
      <div className="widget__content">
        <img src="https://qphs.fs.quoracdn.net/main-thumb-ti-1577737-50-xppytrdppqycxvkfunshartgkwzgtdvc.jpeg" alt='' />
        <div className="widget__contentTitle">
          <h5>Communication Skills</h5>
                <p>Share your experience, tips & tricks to deal with people.</p>
        </div>
      </div>
      <div className="widget__content">
        <img src="https://qphs.fs.quoracdn.net/main-thumb-ti-1577737-50-xppytrdppqycxvkfunshartgkwzgtdvc.jpeg" alt='' />
        <div className="widget__contentTitle">
          <h5>UPSC preparation</h5>
                <p>Journey through preparation.</p>
        </div>
      </div>
      <div className="widget__content">
        <img src="https://qphs.fs.quoracdn.net/main-thumb-ti-1579235-50-vfhnxednupdhnpeowbbbmxsyposlwktm.jpeg" alt='' />
        <div className="widget__contentTitle">
          <h5>Artificial Intelligence</h5>
                <p>Bringing Humans closer to Machines</p>
        </div>
      </div>
      <div className="widget__content">
        <img
          src="https://qphs.fs.quoracdn.net/main-thumb-ti-1578647-100-xkggvbyzfkvzhyklewtkjijefekqbazb.jpeg"
          alt=""
        />
        <div className="widget__contentTitle">
          <h5>Stock Market Strategies</h5>
          <p>Everything about investing in Stock...</p>
        </div>
      </div>
      <div className="widget__content">
        <img
          src="https://qphs.fs.quoracdn.net/main-thumb-ti-1711686-100-glvgnbatdxpjbhrkyphlfamqrryfccvp.jpeg"
          alt=""
        />
        <div className="widget__contentTitle">
          <h5>Architecture World</h5>
          <p>All about civil architecture...</p>
        </div>
      </div>
      <div className="widget__content">
        <img src="https://qphs.fs.quoracdn.net/main-thumb-ti-1578964-50-wluqlsrxuhiiyyehaqquhlcysqgzbbez.jpeg" alt='' />
        <div className="widget__contentTitle">
          <h5>Learn MS Excel</h5>
          <p>Microsoft Excel Tricks, Tips and Tutorials.</p>
        </div>
      </div>
      <div className="widget__content">
       <img src="https://qphs.fs.quoracdn.net/main-thumb-ti-1585492-50-uwynlpwosatbmwdxxhtllqocjembbqwv.jpeg" alt='' />
            <div className="widget__contentTitle">
                <h5>Learn MS Excel</h5>
                <p>Microsoft Excel Tricks, Tips and Tutorials</p>
        </div>
      </div>
    </div>
  );
}

export default WidgetContent;
